export const padPage = {
  mine: {
    mine: '我的',
    person: '个人',
    enterprise: '企',
    shareIntelligentDesign: '分享福昕智装',
    intelligentDesignPC: '智能设计 — PC端',
    cloudServicePremiumVersion: '云服务 — 尊享版',
    cloudServicesEnterpriseEdition: '云服务 — 企业版',
    resetPasswords: '重置密码',
    switchAccount: '切换账号',
    privacyPolicy: '隐私政策',
    userAgreement: '用户协议',
    feedback: '意见反馈',
    about: '关于',
    closeAccount: '注销账号',
    logOut: '退出登录',
    passwordResetSucceeded: '重置密码成功',
    memberName: '福昕智装会员',
    baseMemberName: '福昕智装·基础会员',
    seniorMemberName: '福昕智装·高级会员',
    jointMemberName: '企业联合会员',
    jointMemberTip: '6大权益 助力设计与施工',
    memberTip: '海量商品资源、真实户型，解锁高效设计',
    openMembership: '开通会员',
  },
  login: {
    pleaseCheckProtocol: '请勾选协议',
    pleaseEnterValidPhoneNumber: '请输入有效的手机号码',
    pleaseEnterPhoneNumber: '请输入手机号',
    pleaseEnterVerificationCode: '请输入验证码',
    resend: '重新发送{count}',
    getCode: '获取验证码',
    pleaseEnterAccount: '请输入账号',
    pleaseEnterPassword: '请输入密码',
    verificationCode: '验证码',
    forgetPassword: '忘记密码',
    accountPasswordLogin: '账号密码登录',
    phoneCodeLogin: '手机验证码登录',
    readAndAgree: '我已阅读并同意',
    userAgreement: '《用户协议》',
    privacyPolicy: '《隐私政策》',
    createdUnregistered: '未注册的手机号也将自动创建账号',
    and: '及',
    phoneOrAccount: '手机验证或账号登录',
    wxLogin: '微信登录',
    codeError: '验证码错误，请重新输入',
    reLogin: '账号或密码错误，请重新登录'
  },
  selectOrganization: {
    enterBusinesses: '你可进入以下企业',
    boundAccount: '{phone}<span class="content">已在以下企业或组织绑定了账号，你可进入以下任一企业或组织</span>',
    personalEdition: '个人版',
    enterpriseAccount: '企业账号',
    applyTrial: '申请试用企业版',
    selectAccount: '选择账号',
  },
  applyTrial: {
    pleaseEnterEnterpriseName: '请输入企业名称',
    pleaseEnterName: '请输入姓名',
    pleaseSelectPosition: '请选择职务',
    appliedSuccessfully: '申请成功',
    pleaseEnterPhoneNumber: '请输入您的手机号码',
    submit: '提交',
    cancel: '取消',
    nextStep: '下一步',
    confirm: '确定',
    share: '分享',
    download: '下载',
    delete: '删除',
  },
  base: {
    noData: '暂无数据',
  }
};
